import template from './template.html';
import controller from './controller';

export default {
  url: '?alertType&alertValue',
  abstract: true,
  params: {
    alertType: {
      type: 'string',
      value: undefined,
      squash: true,
      dynamic: true
    },
    alertValue: {
      type: 'string',
      value: undefined,
      squash: true,
      dynamic: true
    }
  },
  views: {
    'root@': {
      template,
      controller
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/controllers/application/index.js